// Component: Divider
// Author: neha
import * as React from 'react';
import DividerNPM from '@rotaryintl/component-divider';

export default function Divider(props) {
  return (
    <>
      <DividerNPM color={props.fields?.Color?.fields?.Value?.value} style={props.fields?.Style?.fields?.Value?.value} />
    </>
  );
}
